export default "__VITE_ASSET__BBIgohoq__"